import { createFileRoute, notFound } from "@tanstack/react-router";

import { CommunityView } from "@/components/pages/CommunityView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/community")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/community",
          ...meta[params.locale].community,
        })
      : {},
  component: CommunityRoute,
});

function CommunityRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <CommunityView locale={locale} />;
}
